import axiosClient from "utils/api/axios-client";

const voucherApi = {
  getAll: (params) => {
    const url = "/api/v1/driver/vouchers";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/driver/vouchers/${id}`;
    return axiosClient.get(url);
  },
  create: (voucher, formData = null) => {
    const url = `/api/v1/driver/vouchers/`;
    return axiosClient.post(url, formData || voucher, {
      headers: formData ? { "Content-Type": "multipart/form-data" } : {},
    });
  },
  update: (voucher, formData = null) => {
    const url = `/api/v1/driver/vouchers/${voucher._id}`;
    return axiosClient.put(url, formData || voucher, {
      headers: formData ? { "Content-Type": "multipart/form-data" } : {},
    });
  },
  delete: (id) => {
    const url = `/api/v1/driver/vouchers/${id}`;
    return axiosClient.delete(url);
  },
  getCode: () => {
    const url = `/api/v1/driver/vouchers/random-code`;
    return axiosClient.get(url);
  },
};

export default voucherApi;
